export class LanguagePickerComponent {

  _languagePickerWrapperEl = null;
  _selectedLanguageEl = null;
  _languagesListWrapperEl = null;
  _languagesListElHeight = null;
  _isListExpanded = false;

  init() {
    this._languagePickerWrapperEl = document.querySelector('.language-picker-wrapper');

    if (this._languagePickerWrapperEl) {
      this.afterComponentRender();
    }
  }

  afterComponentRender() {
    this._selectedLanguageEl = this._languagePickerWrapperEl.querySelector('.selected-language');
    this._languagesListWrapperEl = this._languagePickerWrapperEl.querySelector('.languages-list');
    this._languagesListElHeight = this._languagesListWrapperEl.querySelector('ul').offsetHeight;

    this.setLanguagesLinks();
    this.toggleLanguagesList();
    this.onClickAnywhere();
  }

  setLanguagesLinks() {
    this._languagesListWrapperEl.querySelectorAll('a').forEach(link => {
      if (window.location.pathname === '/') {
        link.href = window.location.pathname + link.getAttribute('data-lang');
      } else {
        const urlFragments = window.location.pathname.split('/');
        const searchParams = new URL(window.location.href).searchParams.toString();

        if (['en', 'pl', 'de'].includes(urlFragments[1])) {
          urlFragments[1] = link.getAttribute('data-lang');
          urlFragments.shift();
        } else {
          urlFragments[0] =  link.getAttribute('data-lang');
        }

        link.href = `${window.origin}/${urlFragments.join('/')}${ searchParams.length > 0 ? `?${ searchParams }` : '' }`;
      }
    });
  }

  toggleLanguagesList() {
    this._selectedLanguageEl.addEventListener('click', () => {
      this._isListExpanded = !this._isListExpanded;

      this._isListExpanded ?
        this._selectedLanguageEl.classList.add('expanded') :
        this._selectedLanguageEl.classList.remove('expanded');

      this._languagesListWrapperEl.style.maxHeight = this._isListExpanded ? `${ this._languagesListElHeight + 4 }px` : 0;
    });
  }

  onClickAnywhere() {
    window.addEventListener('click', e => {
      if (this._isListExpanded && !e.target.closest('.selected-language')) {
        this._selectedLanguageEl.click();
      }
    });
  }
}
